export default __webpack_public_path__ + "static/media/v1-eth.b637b06e.png";